import React from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  onboardingButtonContainer: {
    width: '100%',
    marginTop: theme.spacing(5.5),
  },
}));

export const OnboardingButtonContainer: React.FC = ({ children }) => {
  const { classes } = useStyles();

  return <div className={classes.onboardingButtonContainer}>{children}</div>;
};
